import { Radio, RadioChangeEvent, Space } from 'antd';
import { statusAlarm } from 'models/alarm';
import React from 'react';
import style from './NotificationAlarm.module.scss';
export interface NotificationAlarmProps {
  isNotification: boolean;
  valueAlarm: statusAlarm;
  setValueAlarm: (object: statusAlarm) => void;
  getFilterAlarm: () => void;
}

export default function NotificationAlarm({
  isNotification,
  valueAlarm,
  setValueAlarm,
  getFilterAlarm,
}: NotificationAlarmProps) {
  const onChange1 = (e: RadioChangeEvent) => {
    setValueAlarm({ ...valueAlarm, active_or_cleared: e.target.value });
  };

  const onChange2 = (e: RadioChangeEvent) => {
    setValueAlarm({ ...valueAlarm, acknowledged_or_unacknowledged: e.target.value });
  };

  const onChange3 = (e: RadioChangeEvent) => {
    setValueAlarm({ ...valueAlarm, severity: e.target.value });
  };

  return (
    <div
      className={style.dropdown_content}
      style={{
        display: !isNotification ? 'none' : 'block',
      }}
    >
      <div className={style.filter_alarm}>Filter</div>
      <div className={style.notification}>
        <Radio.Group
          onChange={onChange3}
          value={valueAlarm.severity}
          style={{
            borderBottom: '1px solid #DEDEDE',
            width: '150px',
            margin: '5px',
            display: 'flex',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
          }}
        >
          <Space direction="vertical">
            <Radio value={'ALL'}>ALL</Radio>
            <Radio value={'CRITICAL'}>Critical</Radio>
            <Radio value={'WARNING'}>Warning</Radio>
          </Space>
        </Radio.Group>
        <br />
        <Radio.Group
          onChange={onChange1}
          value={valueAlarm.active_or_cleared}
          style={{
            borderBottom: '1px solid #DEDEDE',
            width: '150px',
            margin: '5px',
          }}
        >
          <Space direction="vertical">
            <Radio value={'ALL'}>ALL</Radio>
            <Radio value={'ACTIVE'}>Active</Radio>
            <Radio value={'CLEARED'}>Cleared</Radio>
          </Space>
        </Radio.Group>
        <br />
        <Radio.Group
          onChange={onChange2}
          value={valueAlarm.acknowledged_or_unacknowledged}
          style={{
            borderBottom: '1px solid #DEDEDE',
            width: '150px',
            margin: '5px',
          }}
        >
          <Space direction="vertical">
            <Radio value={'ALL'}>ALL</Radio>
            <Radio value={'ACK'}>Acknowledged</Radio>
            <Radio value={'UNACK'}>Unacknowledged</Radio>
          </Space>
        </Radio.Group>
      </div>
      <div className={style.btn_filter_alarm}>
        <div onClick={() => getFilterAlarm()}>Submit</div>
      </div>
    </div>
  );
}
